import { StyleSheet } from 'react-native';
import { theme } from '../../../theme';

export const reviewSlipEditorStyles = StyleSheet.create({
  container: {
    paddingHorizontal: 12,
    paddingBottom: 12,
  },
  status: {
    paddingVertical: 12,
    alignItems: 'center',
  },
  statusText: {
    fontSize: 12,
    color: theme.gray[500],
  },
});
